import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum MetaDeletionStatus {
  Pending = "pending",
  Finished = "finished",
}

export const checkMetaDeletionStatus = {
  name: "checkMetaDeletionStatus" as const,
  input: z.null(),
  output: z
    .object({
      status: createEnum(MetaDeletionStatus),
      confirmationId: z.string(),
    })
    .nullable(),
};
